var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fds-egb-portfolio-list"},[_c('fds-portfolio-list',{attrs:{"locale":_vm.locale,"items-per-page":_vm.itemsPerPage},on:{"on-portfolio-create":_vm.onPortfolioCreate,"table-row-click":_vm.onTableRowClick,"table-row-key-click":_vm.onTableRowKeyClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }